import type { ApiResponse } from 'src/common/interfaces';
import type { CertificateExamSlug, CertificationExamResponse, CertificationPurchaseAvailability, CertificationResultsData } from 'src/common/interfaces/certifications';
import { RTKQueryTag } from 'src/common/constants';
import { CertificationType } from 'src/common/enums/certification';
import { apiSlice } from 'src/features/api/api-slice';
const certificationEndpoints = {
  [CertificationType.SAL1]: 'certification/create-sal1-exam',
  [CertificationType.PT1]: 'certification/create-pt1-exam'
};
const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createCertification: builder.mutation<CertificateExamSlug, {
      certificationType: CertificationType;
    }>({
      query: ({
        certificationType
      }) => ({
        url: certificationEndpoints[certificationType],
        method: 'POST'
      })
    }),
    getPreviousResults: builder.query<CertificationResultsData[], {
      certificationType: string;
    }>({
      query: ({
        certificationType
      }) => ({
        url: 'certification/results/previous',
        method: 'GET',
        params: {
          certificationType
        }
      }),
      transformResponse: (response: ApiResponse<CertificationResultsData[]>) => response.data ?? [],
      providesTags: [RTKQueryTag.CertificationPreviousResults]
    }),
    getExamPurchaseData: builder.query<CertificationPurchaseAvailability | null, {
      certificationType: string;
    }>({
      query: ({
        certificationType
      }) => ({
        url: 'certification/purchase/active-purchase',
        method: 'GET',
        params: {
          certificationType
        }
      }),
      transformResponse: (response: ApiResponse<CertificationPurchaseAvailability>) => response?.data ?? null,
      providesTags: [RTKQueryTag.CertificationPurchase]
    }),
    getCertificationExamsData: builder.query<CertificationExamResponse[] | [], {
      filters: Record<string, string>;
    }>({
      query: ({
        filters
      }) => ({
        url: 'certification/exams',
        method: 'GET',
        params: Object.fromEntries(Object.entries(filters).map(([key, value]) => [`filter[${key}]`, value]))
      }),
      transformResponse: (response: ApiResponse<CertificationExamResponse[]>) => response?.data ?? [],
      providesTags: [RTKQueryTag.CertificationExams]
    })
  })
});
export const {
  useCreateCertificationMutation,
  useGetPreviousResultsQuery,
  useGetExamPurchaseDataQuery,
  useGetCertificationExamsDataQuery,
  endpoints
} = extendedApiSlice;